module.exports = __webpack_public_path__ + "static/media/truck.cf19613d.svg";